import { Box, Paper, styled, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Content } from '@backstage/core-components';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  margin: theme.spacing(2.5, 0),
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
    margin: theme.spacing(1.5, 0),
  },
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
  },
}));

export const StyledContent = styled(Content)(({ theme }) => ({
  maxWidth: 1000,
  width: '100%',
  marginRight: 'auto',
  padding: theme.spacing(2, 3),
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
    padding: theme.spacing(2),
  },
}));

export const FormContainer = styled('form')({
  gap: 8,
  display: 'flex',
  flexDirection: 'column',
});

export const TitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
}));

export const RequiredFieldNote = styled(Typography)({
  fontStyle: 'italic',
  display: 'block',
});

export const FormRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
}));

export const BackRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  marginBottom: theme.spacing(3),
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(1.5),
}));

export const SectionDivider = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  margin: theme.spacing(2.5, 0),
}));

export const SmoothReveal = styled(Box)({
  transition:
    'max-height 0.5s ease-in-out, opacity 0.5s ease-in-out, margin-top 0.5s ease-in-out',
});

export const useSmoothRevealClasses = makeStyles({
  open: {
    maxHeight: 1200,
    opacity: 1,
    marginTop: 4,
  },
  closed: {
    maxHeight: 0,
    opacity: 0,
    marginTop: 0,
  },
});
